import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { flexRender } from '@tanstack/react-table';
import { Space } from '../../Space/src/Space.js';
import modules_67e042e7 from '../styles/Head.module.less.js';
import { Filter } from './Filter.js';
import { Sorter } from './Sorter.js';

const Head = (props) => {
    const { header, style, ...restProps } = props;
    const cx = useStyles(modules_67e042e7);
    const isFilterAvailable = header.column.getCanFilter();
    const isSortAvailable = header.column.getCanSort();
    const containerClassNames = cx('h-p-16', {
        pointer: isSortAvailable || isFilterAvailable,
    });
    return (React.createElement("th", { colSpan: header.colSpan, style: { width: `${header.getSize()}px`, ...style }, ...restProps }, header.isPlaceholder ? null : (React.createElement(Space, { className: containerClassNames, onClick: header.column.getToggleSortingHandler(), align: "center", size: 4 },
        React.createElement("div", { className: cx('cell') }, flexRender(header.column.columnDef.header, header.getContext())),
        React.createElement(Space, { size: 0, align: "center", className: cx('icons'), inline: true },
            isSortAvailable ? React.createElement(Sorter, { isSorted: header.column.getIsSorted() }) : null,
            isFilterAvailable ? React.createElement(Filter, { column: header.column }) : null)))));
};

export { Head };
//# sourceMappingURL=Head.js.map
